module.exports = __webpack_public_path__ + "static/media/3-kanskje.433a0c35.mp3";